// src/pages/BlogDetails.jsx
import { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import ApiService from "../api/ApiService";
import "../css/blogDetails.css";
// import EventsHome from "../components/homepage/EventsHome";
import GoToTop from "../helpers/GoToTop";
import MetaData from "../helpers/MetaData";
import PageHeader from "../components/common/PageHeader";
import BlogSlider from "../components/blog/BlogSlider";

const BlogDetails = () => {
 const { id } = useParams();
  const [blogDetails, setBlogDetails] = useState(null);
  const [categoriesList, setCategoriesList] = useState([]);
  const [top, setTop] = useState(0);

  const fetchBlogDetails = useCallback(async () => {
    try {
      const blogs = await ApiService.fetchBlogs();
      const blog = blogs.find(b => b.slug === id);
      setBlogDetails(blog);
      setCategoriesList(blogs);
    } catch (error) {
      console.error("Error fetching blog details:", error);
    }
  }, [id]);

  const festRef = useCallback((node) => {
    if (node) setTop(node.offsetTop + 355);
  }, []);

  useEffect(() => {
    fetchBlogDetails();
  }, [fetchBlogDetails]);

  const formatDate = (dateString) => moment(dateString).format("DD MMM, YYYY");
  return (
    <>
      <MetaData title="Blogs - ISKCON of Attapur" />
      <PageHeader title="Blog Details" imgSrc="/images/page-header/13.webp" />

      <section className="connect-heading-sec pt-0">
        <div className="container">
          <div className="row">
            <div className="col-md-12 blog-right">
              <div className="blog-details-container" ref={festRef}>
                <div className="row">
                  <div className="col-md-12">
                    <h4 className="main-title mt-4">{blogDetails?.title}</h4>
                    <div className="blog-details-date">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.5 15C3.364 15 0 11.636 0 7.5S3.364 0 7.5 0s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5Zm0-13.75A6.25 6.25 0 1 0 13.75 7.5 6.257 6.257 0 0 0 7.5 1.25Zm1.562 8.956a.625.625 0 0 0 .229-.854L8.125 7.333V3.75a.625.625 0 1 0-1.25 0V7.5c0 .11.029.218.084.313l1.25 2.165a.625.625 0 0 0 1.104.227Z"
                          fill="#666"
                        />
                      </svg>
                      &nbsp;
                      {blogDetails?.date && formatDate(blogDetails.date).toUpperCase()}
                    </div>
                  </div>
                </div>

                {blogDetails?.image && (
                  <div>
                    <img
                      src={`${process.env.REACT_APP_S3_URL}/uploads/blog/${blogDetails.image}`}
                      alt={blogDetails.title || "blog image"}
                      className="blog-img"
                    />
                  </div>
                )}

                {blogDetails?.description && (
                  <div
                    className="description mt-4"
                    dangerouslySetInnerHTML={{ __html: blogDetails.description }}
                    style={{ color: "#7c848d" }}
                  ></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      
          <BlogSlider />
      

      <GoToTop top={top} />
      {/* <EventsHome /> */}
    </>
  );
}

export default BlogDetails



